export const getWrapperStyles = variant => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  padding: '12px 16px',
  borderRadius: ({ shape }) => shape.radius.m,
  backgroundColor: ({ palette }) => palette[variant]?.soft ?? palette.info.soft,
});

export const messageStyles = {
  color: 'text.primary',
};
